
import React from 'react';
import PropTypes from "prop-types";

function ClassTab(props) {
    const rows = [];

    props.src.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
    });
    props.src.forEach((item,index) => {
        rows.push(
            <tr key={index}>
                <td>{item.functionName}</td>
                <td>{item.type}</td>
                <td>{item.args}</td>
                <td>{item.description}</td>
            </tr>
        )
    });

    return (
        <div className="document">
            <table>
                <thead>
                    <tr>
                        <th>Function Name</th>
                        <th>Type</th>
                        <th>args</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </table>
        </div>
    )
}

Document.propTypes = {
    src: PropTypes.array
};

Document.defaultProps = {
    src: "{}"
}

export default ClassTab